// extracted by mini-css-extract-plugin
module.exports = {"panelWrapper":"style_panelWrapper__xA59n","panel":"style_panel__DRGHa"};